import React, { useEffect, useRef, useState } from 'react';
import Editor from '@monaco-editor/react';
import Loader from '../Loader';
import Progress from '../Loaders/Progress';

interface Iprops {
  language?: string;
  theme?: string;
  value: string;
  readOnly?: boolean;
  onUpdate:(value:string) => void;
  selectedFile:any;
}
const CodeEditor = ({ language = 'javascript', theme = 'light', value, readOnly = false, onUpdate, selectedFile }: Iprops) => {
  const editorRef = useRef(null);
  const [isEditorReady, setIsEditorReady] = useState(false);
  // const text = `Hello world`;

  const handleEditorDidMount = (editor, monaco) => {
    editorRef.current = editor;
    setIsEditorReady(true);
  };

  const toggleTheme = () => {
    // setTheme(theme === "light" ? "vs-dark" : "light");
  };
  const onChange = (newValue, e) => {
    // console.log('newValue, e', {newValue, e})
    onUpdate(newValue);
    // setTheme(theme === "light" ? "vs-dark" : "light");
  };

   // Effect to scroll to top when content updates
   useEffect(() => {
    if (selectedFile && editorRef.current) {
      const editor = editorRef.current;
      editor.setScrollTop(0);    // Scroll to top
    }
  }, [selectedFile]);

  return (
    <>
      <Editor
        height="66vh"
        // width={'100%'}
        loading={<Progress progressLabel="Loading..." />}
        defaultLanguage="python"
        theme={theme}
        language={language}
        onMount={handleEditorDidMount}
        value={value}
        onChange={onChange}
        defaultValue={''}
        
        options={{
          quickSuggestions: { other: true, strings: true },
          cursorStyle: 'line',
          formatOnPaste: true,
          formatOnType: true,
          wordWrap: 'on',
          readOnly: readOnly,
          padding: { top: 10 },
          // autoIndent: "full"
        }}
      />
    </>
  );
};

export default CodeEditor;
